import { render } from "./Page-Number.vue?vue&type=template&id=efb7f336"
import script from "./Page-Number.vue?vue&type=script&lang=js"
export * from "./Page-Number.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__